export default "__VITE_ASSET__C1RVCx3z__"